import { routerErrror } from '../route-navigation'

function tabAll() {
  if (!this.$route.params.id) {
    this.$router.push('/').catch(routerErrror)
  } else {
    this.$router
      .push({
        query: {
          tab: undefined,
        },
      })
      .catch(routerErrror)
    this.$store.dispatch('GIFTCODE_GENERIC_REQUEST', {
      game_id: window.localStorage.getItem('game_id'),
    })
    this.$store.dispatch('GIFTCODE_UNIQUE_REQUEST', {
      game_id: window.localStorage.getItem('game_id'),
    })
  }
}

function tabRecieved() {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  }

  if (this.isAuthenticated) {
    if (!this.$route.params.id) {
      this.$store.dispatch('GIFTCODE_HISTORY')
      this.$router
        .push({
          query: {
            tab: 'da-nhan',
          },
        })
        .catch(routerErrror)
    } else {
      this.$store.dispatch('GIFTCODE_HISTORY', {
        game_id: window.localStorage.getItem('game_id'),
      })
      this.$router
        .push({
          query: {
            tab: 'da-nhan',
          },
        })
        .catch(routerErrror)
    }
  }
}

function tabExchange() {
  if (window.localStorage.getItem('can_use_code') === 'false') {
    this.$store.commit('SERVER_REQUEST', [])
  }
  if (!this.isAuthenticated) {
    this.status.login_required = true
  }
  this.$store.commit('updateCode', '')
  if (!this.$route.params.id) {
    if (this.$route.query.tab === 'doi-code') {
      return
    } else {
      this.$router
        .push({
          path: 'giftcode',
          query: {
            tab: 'doi-code',
          },
        })
        .catch(routerErrror)
    }
  } else {
    this.$router
      .push({
        params: this.$route.params.id,
        query: {
          eid: this.$route.query.eid,
          tab: 'doi-code',
        },
      })
      .catch(routerErrror)
  }
}

export { tabAll, tabRecieved, tabExchange }
